import { useState } from "react";
import ProfileDropdown from "./ProfileDropdown";
import { OptimizedSvg } from "@components/common/OptimizedSvg";
import { userProfile } from "@tvet-mis/psda-assets";
import { useProfile } from "./services/GetProfile";
import isEmpty from "@utils/isEmpty";
import { useAttachment } from "@hooks/useAttachment";
import { CircularProgress } from "@mui/material";

const Profile = () => {
	const { data } = useProfile();
	const profilePicture = data?.profilePicture;
	const firstName = data?.firstName;
	const lastName = data?.lastName;
	const [imageError, setImageError] = useState(false);

	// Fetch profile picture via attachment hook (when it's an object key, not full URL or blob)
	const isDirectUrl =
		profilePicture?.startsWith("http://") ||
		profilePicture?.startsWith("https://") ||
		profilePicture?.startsWith("blob:");
	const { data: fetchedProfileUrl, isLoading: isLoadingProfile } = useAttachment(
		isDirectUrl ? null : profilePicture || null,
		!!profilePicture && !isDirectUrl
	);
	const profilePictureUrl = isDirectUrl ? profilePicture : fetchedProfileUrl;

	const hasName = !isEmpty(firstName) || !isEmpty(lastName);
	const fullName = hasName ? `${firstName || ""} ${lastName || ""}`.trim() : "";

	return (
		<div className="flex items-center gap-1 bg-gray-100 rounded-full pl-3 pr-2 py-1.5">
			{isLoadingProfile ? (
				<div className="h-10 w-10 shrink-0 rounded-full flex items-center justify-center mr-1">
					<CircularProgress size={20} />
				</div>
			) : profilePictureUrl && !imageError ? (
				<img
					src={profilePictureUrl}
					alt="Profile"
					className="h-10 w-10 shrink-0 rounded-full object-cover mr-1"
					onError={() => setImageError(true)}
				/>
			) : (
				<OptimizedSvg src={userProfile} alt="user profile" className="user-profile shrink-0 mr-1" cacheKey="user-profile" />
			)}
			{hasName && (
				<div className="min-w-0 pr-1">
					<div
						className="text-sm font-semibold leading-tight text-gray-900 truncate max-w-[100px] sm:max-w-[120px] md:max-w-[160px] lg:max-w-[130px]"
						title={fullName}>
						{fullName}
					</div>
				</div>
			)}

			<ProfileDropdown />
		</div>
	);
};

export default Profile;
